angular.module('utility-ng-kernel', []);

export * from './core/command_builder';
export * from './core/query_mediator';
export * from 'utility-ts-orm';

import { Datasource } from 'utility-ts-orm';
import { QueryMediator } from './core/query_mediator';

angular.module('utility-ng-kernel')
  /**
   * @deprecated do not use the QueryMediator, just import the ORMMediator
   */
  .service('QueryMediator', QueryMediator)
  .constant('Datasource', Datasource);



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-kernel/dist/main.ts